import React from 'react';

function Header(){
	return(
		<div className="header">
			<div>
				<img src="/assets/3.png" alt="logo" className="logo"/>
		 </div>
		 <img src="/assets/User_Active.png" alt="logo2" className="userActive"/>
		</div>
	)
}

export default Header